<template>
  <div class="recycle-bin-content">
    <gat-head />
    <div class="category-nav">
      <div class="nav-inner">
        <div class="select-box">
          <span>文件类型：</span>
          <el-select
            v-model="recycleType"
            placeholder="请选择文件类型"
            @change="dropdwonChange"
            filterable
          >
            <!-- @visible-change="dropdwonVisibleChange"--> 
            <el-option
              v-for="item in fileTypesArr"
              :key="item.id"
              :label="item.dictTypeDesc"
              :value="item.dictId"
              @mouseover.native="optMouseOver"
            >
            </el-option>
          </el-select>
        </div>
        <!--  搜索部分-->
        <div class="ipt">
          <el-input
            placeholder="请输入文件名称"
            v-model.trim="searchKey"
            @keyup.enter.native="GetFileByKey"
          >
            <i slot="suffix" class="icon-search-box" @click="GetFileByKey">
              <span class="el-icon-search"></span>
            </i>
          </el-input>
        </div>
      </div>
    </div>

    <!-- list of filesList-->
    <section class="recycle-main">
      <el-table :data="filesList" stripe style="width:100%">
        <el-table-column prop="name" label="名称" width="400px">
          <template slot-scope="scope">
            <span :title="scope.row.name" class="t-name ellipsis">{{ scope.row.name }}</span>
            <span v-if="scope.row.version" class="e-type">【{{ scope.row.version }}】</span>
            <span v-if="scope.row.editorType" class="e-type"
              >【{{ scope.row.editorType }}】</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column prop="updateTime" label="删除时间"> </el-table-column>
        <el-table-column label="操作" width="200px">
          <template slot-scope="scope">
            <el-button @click="recoverFile(scope.row)" type="text" size="small"
              >放回原处</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <span
              class="delete-icon"
              @click.stop="activeDeletePopup(scope.row)"
            >
            </span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination" v-if="filesList.length">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page.sync="pagination.pageNum"
          :page-size="pagination.pageSize"
          :pager-count="5"
          layout="slot, prev, pager, next"
          :total="pagination.total"
        ></el-pagination>
      </div>
    </section>

    <!--弹框组件-->
    <div class="popup-list">
      <!-- 删除 -->
      <gat-popup
        :class="['popup-delete', popupActive === 'delete' ? 'on' : 'off']"
        :title="''"
        :primary-button="'删除'"
        @cancel="cancelPopup('delete')"
        @confirm="confirmDel"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span class="title">确定删除该文件吗？</span>
            </div>

            <div class="content">删除后不可恢复哦</div>
          </div>
        </template>
      </gat-popup>
      <!-- 文件恢复重名 -->
      <gat-popup
        :class="[
          'popup-recover-mode',
          popupActive === 'recover-mode' ? 'on' : 'off',
        ]"
        :title="'文件恢复提醒'"
        :primary-button="'替换'"
        :cancel-button="'跳过'"
        @cancel="recoverMode"
        @confirm="recoverMode('replace')"
      >
        <template v-slot:content>
          <div class="popup-recover-cnt">
            <div class="head">
              <span class="title">目标已包含同名的文件</span>
            </div>

            <div class="content">替换同名文件或跳过同名文件？</div>
          </div>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
import RECYCLE from '@/axios/recycleBin/RecycleBin'
import GatPopup from '@/components/common/GatPopup'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'
import { mapGetters } from 'vuex'

export default {
  name: 'recycleBin',
  components: { GatPopup, IconInfoHelp },
  data() {
    return {
      recycleType: null,
      isPerProject: false,
      fileTypesList: [],
      searchKey: '',
      filesData: {
        records: [
          // {
          //   name: '创作1',
          //   createTime: '2020-11-03 11:11:59',
          //   updateTime: '2021-01-12 16:34:06',
          // },
        ],
      },
      popupActive: '',
      conflicFile: {}, //有命名冲突的文件数据
      delFileObj: {}, //要彻底删除的文件对象
      pagination: {
        pageSize: 10,
        pageNum: 1,
        total: null,
      },
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
      },
    }
  },

  computed: {
    filesList() {
      if (this.filesData.records) {
        return this.filesData.records
      } else {
        return []
      }
    },
    fileTypesArr() {
      let arr
      let fileTypesList = this.fileTypesList
      if (!this.userRole) {
        return []
      } else if (this.userRole != 2) {
        // 非学生角色显示的数据
        return fileTypesList
      } else {
        if (fileTypesList.length === 0) return []
        // 学生角色显示的数据
        arr = fileTypesList.filter(
          (item) =>
            item.dictTypeDesc !== '课程实训' && item.dictTypeDesc !== '实训项目'
        )
        // console.log('arr', arr)
        return arr
      }
    },
    ...mapGetters(['accountInfo', 'userRole']),
  },
  watch: {
    recycleType(val) {
      if (val) {
        let dictTypeDesc
        this.searchKey = '' //对搜索框进行删除
        this.fileTypesArr.forEach((item) => {
          if (item.dictId == val) {
            dictTypeDesc = item.dictTypeDesc
          }
        })
        if (/我的项目/.test(dictTypeDesc)) this.isPerProject = true
        this.getRecycleList()
      }
    },
    fileTypesArr(arr) {
      if (arr.length) {
        this.recycleType = this.fileTypesArr[0].dictId
        this.getRecycleList()
      }
    },
  },
  created() {
    this.getComDictionary()
  },
  mounted() {},
  methods: {
    handleCurrentChange(pageIdx) {
      this.pagination.pageNum = pageIdx
      this.getRecycleList()
      // this.getDatasetPageList(pageIdx, this.orderType, this.searchType);
    },
    // 模型类别选中
    dropdwonChange(val) {
      // var name = this.$route.name,
    },
    // 搜索
    GetFileByKey() {
      let searchKey = this.searchKey.trim()
      // if (!searchKey) return;
      this.getRecycleList(searchKey)
    },
    /**
     * 恢复回收站列表数据 @data onlyId 唯一id; recycleType 文件类型
     */
    async recoverFile(item) {
      let onlyId = item.onlyId,
        recycleType = this.recycleType
      let data = {
        onlyId,
        recycleType,
      }
      this.conflicFile = { ...data }
      this.conflicFile.name = item.name
      this.conflicFile.version = item.version ||''
      let res = await RECYCLE.recoveryRecycleData(data)

      if (res && res.isSuccess) {
        this.$message.success(res.returnMsg)
        this.searchKey = ''
        this.getRecycleList()
      } else if (res && res.returnCode === 409) {
        this.popupActive = 'recover-mode'
      } else {
        this.$message.error(res.returnMsg)
      }
    },

    /**
     * 选择恢复同名文件的方式 ：解决重名冲突
     *  @data name 文件名称； onlyId 唯一id; recycleType 文件类型 solveType 解决类型：1：替换目标中的文件；2：跳过该文件
     *  */
    async recoverMode(mode) {
      let data = { ...this.conflicFile }
      if (mode === 'replace') {
        data.solveType = 1
      } else if (mode === 'firstOff') {
        // 右上角的删除图标不做处理
        this.popupActive = ''
        return
      } else {
        data.solveType = 2
      }
      let res = await RECYCLE.solveDoubleName(data) //api请求
      if (res && res.isSuccess) {
        this.$message.success(res.returnMsg)
        this.searchKey = ''
        this.conflicFile = {}
        this.popupActive = ''
        this.getRecycleList()
      } else {
        this.$message.error(res.returnMsg)
      }
    },
    // 删除项目
    activeDeletePopup(data) {
      this.delFileObj = data
      this.popupActive = 'delete'
    },

    //  取消弹窗
    async confirmDel() {
      let { onlyId } = this.delFileObj,
        { recycleType } = this,
        data = {
          onlyId,
          recycleType,
        }

      let res = await RECYCLE.deleteRecycleData(data) //api请求
      if (res && res.isSuccess) {
        this.$message.success(res.returnMsg)
        this.searchKey = ''
        this.getRecycleList()
      } else {
        this.$message.error(res.returnMsg)
      }
      this.popupActive = ''
    },
    //  取消弹窗
    cancelPopup() {
      this.popupActive = ''
    },
    // 模型分类选中下拉鼠标经过事件
    optMouseOver(evt) {
      var target = evt.target
      // this.Comment.current = target.textContent;
    },
    /**
     * 获取回收站文件类型 @data dictTypeCode:RecycleType
     */
    async getComDictionary() {
      let data = {
        dictTypeCode: 'RecycleType',
      }
      let res = await RECYCLE.getComDictionary(data)
      if (res.isSuccess) {
        this.fileTypesList = res.data
        return res
      }
    },
    /**
     * 查询回收站首页列表数据 @data  name 名称； recycleType userId pageNum pageSize
     */
    async getRecycleList(name) {
      let recycleType = this.recycleType,
        userId = this.accountInfo.userId,
        { pageNum, pageSize } = this.pagination,
        data = {
          name: name,
          recycleType,
          userId,
          pageNum,
          pageSize,
        }
      let res = await RECYCLE.getRecycleList(data)
      if (res.isSuccess) {
        this.filesData = res.data
        this.pagination.total = res.data.total || 0
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import './recycleBin.scss';
</style>
